import React from "react";
import ReactWOW from "react-wow";

// https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=16990

class About extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="about" className="white">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h2>{msg.introduction}</h2>
              </div>
              <p>{msg.introDesc01}</p>
              <p>{msg.introDesc01p}</p>
              <ul>
                <li>{msg.introLi01}</li>
                <li>{msg.introLi02}</li>
                <li>{msg.introLi03} </li>
              </ul>
            </div>
          </div>
          <div className="flex-box">
            {msg.introData.map(it => {
              let p2 = null;
              if (it.desc02) {
                p2 = <p>{it.desc02}</p>;
              }
              return (
                <ReactWOW key={it.title} animation="fadeInUp" delay="0.1s">
                  <div className="box box-2">
                    <h5>{it.title}</h5>
                    <img src={"images/" + it.image} alt="" />
                    <p>{it.desc + " "}</p>
                    {p2}
                  </div>
                </ReactWOW>
              );
            })}
          </div>
          <div className="section-title">
            <h2 className="title-2">{msg.introAbout}</h2>
          </div>
          <p>{msg.introAboutDesc01} </p>
          <p>{msg.introAboutDesc02} </p>
          <p>{msg.introAboutDesc03}</p>
        </div>
      </section>
    );
  }
}

export default About;
